import React, {Component} from 'react';
import _ from 'underscore';
import CONST from '../../CONST';
import withLocalize from '../withLocalize';
import TextInput from '../TextInput';
import * as roomNameInputPropTypes from './roomNameInputPropTypes';
import * as RoomNameInputUtils from '../../libs/RoomNameInputUtils';

class RoomNameInput extends Component {
    constructor(props) {
        super(props);

        this.setModifiedRoomName = this.setModifiedRoomName.bind(this);
        this.setSelection = this.setSelection.bind(this);

        this.state = {
            selection: undefined,
        };
    }

    /**
     * Calls the onChangeText callback with a modified room name
     * @param {Event} event
     */
    setModifiedRoomName(event) {
        const roomName = event.nativeEvent.text;
        const modifiedRoomName = RoomNameInputUtils.modifyRoomName(roomName);
        this.props.onChangeText(modifiedRoomName);

        // if custom component has onInputChange, use it to trigger changes (Form input)
        if (_.isFunction(this.props.onInputChange)) {
            this.props.onInputChange(modifiedRoomName);
        }

        // Prevent cursor jump behaviour:
        // Check if newRoomNameWithHash is the same as modifiedRoomName
        // If it is then the room name is valid (does not contain unallowed characters); no action required
        // If not then the room name contains unvalid characters and we must adjust the cursor position manually
        // Read more: https://github.com/Expensify/App/issues/12741
        const oldRoomNameWithHash = this.props.value || '';
        const newRoomNameWithHash = `${CONST.POLICY.ROOM_PREFIX}${roomName}`;
        if (modifiedRoomName !== newRoomNameWithHash) {
            const offset = modifiedRoomName.length - oldRoomNameWithHash.length;
            const selection = {
                start: this.state.selection.start + offset,
                end: this.state.selection.end + offset,
            };
            this.setSelection(selection);
        }
    }

    /**
     * Set the selection
     * @param {Object} selection
     */
    setSelection(selection) {
        this.setState({selection});
    }

    render() {
        return (
            <TextInput
                ref={this.props.forwardedRef}
                disabled={this.props.disabled}
                label={this.props.translate('newRoomPage.roomName')}
                accessibilityLabel={this.props.translate('newRoomPage.roomName')}
                accessibilityRole={CONST.ACCESSIBILITY_ROLE.TEXT}
                prefixCharacter={CONST.POLICY.ROOM_PREFIX}
                placeholder={this.props.translate('newRoomPage.social')}
                onChange={this.setModifiedRoomName}
                value={this.props.value.substring(1)} // Since the room name always starts with a prefix, we omit the first character to avoid displaying it twice.
                selection={this.state.selection}
                onSelectionChange={(event) => this.setSelection(event.nativeEvent.selection)}
                errorText={this.props.errorText}
                autoCapitalize="none"
                onBlur={this.props.onBlur}
                autoFocus={this.props.autoFocus}
                maxLength={CONST.REPORT.MAX_ROOM_NAME_LENGTH}
            />
        );
    }
}

RoomNameInput.propTypes = roomNameInputPropTypes.propTypes;
RoomNameInput.defaultProps = roomNameInputPropTypes.defaultProps;

export default withLocalize(
    React.forwardRef((props, ref) => (
        <RoomNameInput
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
            forwardedRef={ref}
        />
    )),
);
